import React from "react";
import { SearchContext } from "../Layout/Models/SearchContext";

const defaultVal = {
  shouldReload: false,
  searchQuery: "",
  setReloadFeedback: (reload: Boolean) => {}
};

export const SearchbarContext = React.createContext<{
  shouldReload: Boolean;
  searchQuery: string;
  context?: SearchContext;
  setReloadFeedback: (reload: Boolean, context?: SearchContext, query?: string) => void;
}>(defaultVal);
